import { ExpandLess, ExpandMore } from "@mui/icons-material";
import GroupIcon from "@mui/icons-material/Group";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import DescriptionIcon from "@mui/icons-material/Description";
import DashboardIcon from "@mui/icons-material/Dashboard";
import WarningIcon from "@mui/icons-material/Warning";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GroupsIcon from "@mui/icons-material/Groups";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useLogout } from "../../hooks/useLogout";
import { useIsSuperAdmin } from "../../hooks/useIsSuperAdmin";
import { getStoredRole, isUserAdminRole } from "../../constants/roles";
import "../../styles/navbar/Navbar.css";

// A user_admin may reach user management and groups (groups are part of
// managing users), plus the overview landing page.
const USER_ADMIN_ALLOWED_HREFS = [
  "/admin/overview",
  "/admin/user",
  "/admin/group",
];

export default function Navbar(props) {
  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const [activeChildDropDown, setActiveChildDropDownk] = useState(null);
  // Parent level
  const [open, setOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  // Child level
  const [openChild, setOpenChild] = useState(false);
  const [openChildIndex, setOpenChildIndex] = useState(null);

  const { logout: logoutUser } = useLogout();
  const { isSuperAdmin } = useIsSuperAdmin();
  const restrictedToUsers = isUserAdminRole(getStoredRole());

  const logout = async (e) => {
    e.preventDefault();
    console.log("loggar ut");
    let response = await logoutUser();

    if (response && !response.error) {
      window.location.href = "/login";
    }
  };

  const navlinks = [
    ...(isSuperAdmin
      ? [
          {
            name: "Organisationer",
            icon: <CorporateFareIcon />,
            href: "/admin/organisations",
          },
        ]
      : []),
    {
      name: "Översikt",
      icon: <DashboardIcon />,
      href: "/admin/overview",
    },
    {
      name: "Grupper",
      icon: <GroupsIcon />,
      href: "/admin/group",
    },
    {
      name: "Användare",
      icon: <PeopleIcon />,
      href: "/admin/user",
    },
    {
      name: "Anläggningar",
      icon: <BusinessIcon />,
      href: "/admin/facility",
    },
    {
      name: "Dokument",
      icon: <DescriptionIcon />,
      href: "/admin/document",
    },
    {
      name: "Checklistor",
      icon: <AssignmentIcon />,
      href: "/admin/evacuation",
    },
    {
      name: "Larm",
      icon: <NotificationsActiveIcon />,
      href: "/admin/alarm",
    },
    {
      name: "Inställningar",
      icon: <SettingsIcon />,
      href: "/admin/settings",
    },
  ].filter(
    (link) =>
      !restrictedToUsers || USER_ADMIN_ALLOWED_HREFS.includes(link.href)
  );

  function CheckIfParentActive(parent) {
    if (activeChildDropDown) {
      var activeDropChild = parent.links[activeChildDropDown];

      if (
        activeDropChild.links &&
        activeDropChild.links.find((el) => el.href === activeLink)
      ) {
        return true;
      }
    }

    if (parent.links.find((el) => el.href === activeLink)) {
      return true;
    }

    return false;
  }

  function handleClick(index) {
    if (index === openIndex) {
      setOpen(!open);
    } else {
      setOpen(true);
    }
    setOpenIndex(index);
  }
  function handleChildClick(index) {
    if (index === openChildIndex) {
      setOpenChild(!openChild);
    } else {
      setOpenChild(true);
    }
    setOpenChildIndex(index);
  }

  function renderParentLink(item, index) {
    return (
      <div key={index}>
        <NavLink
          to={item.href}
          onClick={() => {
            setActiveLink(item.href);
            if (props.sidebarOpen) {
              props.closeSidebar();
            }
          }}
        >
          {({ isActive }) => (
            <ListItemButton
              style={{
                display: "flex",
                padding: "8px 12px",
                background: isActive ? "rgba(138,17,37,0.15)" : undefined,
                alignItems: "center",
                borderRadius: "10px",
                marginBottom: "2px",
              }}
            >
              <ListItemIcon
                style={{
                  color: isActive ? "#c41830" : "rgba(255,255,255,0.4)",
                  minWidth: 40,
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                style={{
                  color: isActive ? "white" : "rgba(255,255,255,0.65)",
                }}
              >
                {item.name}
              </ListItemText>
            </ListItemButton>
          )}
        </NavLink>
      </div>
    );
  }

  function renderParentDropDown(item, index) {
    const isParentActive = CheckIfParentActive(item);
    return (
      <div key={index}>
        <ListItemButton
          onClick={() => {
            handleClick(index);
          }}
          style={{
            background: isParentActive ? "rgba(138,17,37,0.15)" : undefined,
            borderRadius: "10px",
            color: isParentActive ? "white" : "rgba(255,255,255,0.65)",
            padding: "8px 12px",
            marginBottom: "2px",
          }}
        >
          <ListItemIcon
            style={{
              color: isParentActive ? "#c41830" : "rgba(255,255,255,0.4)",
              minWidth: 40,
            }}
          >
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.name} />
          {open && openIndex === index ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open && openIndex === index} unmountOnExit>
          <List component={"div"} style={{ paddingLeft: "1em" }}>
            {item.links.map((link, i) => {
              if (link.links) {
                return renderChildDropDown(link, i);
              } else {
                return (
                  <NavLink
                    key={i}
                    to={link.href}
                    name={link.href}
                    onClick={() => {
                      setActiveLink(link.href);
                      if (props.sidebarOpen) {
                        props.closeSidebar();
                      }
                    }}
                  >
                    {({ isActive }) => (
                      <div
                        style={{
                          display: "flex",
                          padding: "6px 12px",
                          background:
                            activeLink === link.href
                              ? "rgba(255,255,255,0.05)"
                              : undefined,
                          alignItems: "center",
                          borderRadius: "10px",
                          marginBottom: "1px",
                        }}
                      >
                        <ListItemIcon
                          style={{
                            color:
                              activeLink === link.href
                                ? "#c41830"
                                : "rgba(255,255,255,0.4)",
                            minWidth: 40,
                          }}
                        >
                          {link.icon}
                        </ListItemIcon>
                        <ListItemText
                          style={{
                            color:
                              activeLink === link.href
                                ? "#c41830"
                                : "rgba(255,255,255,0.65)",
                          }}
                        >
                          {link.name}
                        </ListItemText>
                      </div>
                    )}
                  </NavLink>
                );
              }
            })}
          </List>
        </Collapse>
      </div>
    );
  }

  function renderChildDropDown(item, index) {
    const isChildActive = item.links.find((el) => el.href === activeLink);
    return (
      <div key={index}>
        <ListItemButton
          onClick={() => {
            setActiveChildDropDownk(index);
            handleChildClick(index);
          }}
          style={{
            background: isChildActive ? "rgba(138,17,37,0.15)" : undefined,
            borderRadius: "10px",
            color: isChildActive ? "white" : "rgba(255,255,255,0.65)",
            padding: "8px 12px",
            marginBottom: "2px",
          }}
        >
          <ListItemIcon
            style={{
              color: isChildActive ? "#c41830" : "rgba(255,255,255,0.4)",
              minWidth: 40,
            }}
          >
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.name} />
          {openChild && openChildIndex === index ? (
            <ExpandLess />
          ) : (
            <ExpandMore />
          )}
        </ListItemButton>
        <Collapse in={openChild && openChildIndex === index} unmountOnExit>
          <List component={"div"} style={{ paddingLeft: "1em" }}>
            {item.links.map((link, i) => {
              return (
                <NavLink
                  key={i}
                  to={link.href}
                  name={link.href}
                  onClick={() => {
                    setActiveLink(link.href);
                    if (props.sidebarOpen) {
                      props.closeSidebar();
                    }
                  }}
                >
                  {({ isActive }) => (
                    <div
                      style={{
                        display: "flex",
                        padding: "6px 12px",
                        background:
                          activeLink === link.href
                            ? "rgba(255,255,255,0.05)"
                            : undefined,
                        alignItems: "center",
                        borderRadius: "10px",
                        marginBottom: "1px",
                      }}
                    >
                      <ListItemIcon
                        style={{
                          color:
                            activeLink === link.href
                              ? "#c41830"
                              : "rgba(255,255,255,0.4)",
                          minWidth: 40,
                        }}
                      >
                        {link.icon}
                      </ListItemIcon>
                      <ListItemText
                        style={{
                          color:
                            activeLink === link.href
                              ? "#c41830"
                              : "rgba(255,255,255,0.65)",
                        }}
                      >
                        {link.name}
                      </ListItemText>
                    </div>
                  )}
                </NavLink>
              );
            })}
          </List>
        </Collapse>
      </div>
    );
  }

  return (
    <div
      className={props.sidebarOpen ? "overlay" : undefined}
      onClick={(e) => {
        props.closeSidebar();
      }}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={
          props.sidebarOpen ? "navbar-wrapper navbar-open" : "navbar-wrapper"
        }
        style={{ position: "relative" }}
      >
        {/* Logo */}
        <div className="navbar-logo">
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "10px",
              background: "#8a1125",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontFamily: '"Outfit", sans-serif',
                fontWeight: 700,
                fontSize: "16px",
              }}
            >
              V
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                color: "white",
                fontFamily: '"Outfit", sans-serif',
                fontWeight: 600,
                fontSize: "16px",
                lineHeight: 1.2,
              }}
            >
              Varna
            </Typography>
            <Typography
              sx={{
                color: "rgba(255,255,255,0.4) !important",
                fontFamily: '"Outfit", sans-serif',
                fontWeight: 500,
                fontSize: "9px",
                textTransform: "uppercase",
                letterSpacing: "0.25em",
              }}
            >
              Adminpanel
            </Typography>
          </Box>
        </div>

        {/* Section label */}
        <div className="navbar-section-label">Navigation</div>

        {navlinks.map((item, index) => {
          if (item.links) {
            return renderParentDropDown(item, index);
          } else {
            return renderParentLink(item, index);
          }
        })}

        {/* Logout button */}
        <div
          style={{
            position: "absolute",
            bottom: 20,
            width: "calc(100% - 20px)",
            left: 10,
            right: 10,
          }}
        >
          <ListItemButton
            onClick={logout}
            style={{
              display: "flex",
              padding: "8px 12px",
              alignItems: "center",
              borderRadius: "10px",
              backgroundColor: "rgba(255,255,255,0.04)",
              color: "rgba(255,255,255,0.5)",
              width: "100%",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(244,44,4,0.1)";
              e.currentTarget.style.color = "#ff6b4a";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.04)";
              e.currentTarget.style.color = "rgba(255,255,255,0.5)";
            }}
          >
            <ListItemIcon
              style={{
                color: "inherit",
                minWidth: 40,
              }}
            >
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText
              style={{
                textTransform: "none",
                color: "inherit",
              }}
            >
              Logga ut
            </ListItemText>
          </ListItemButton>
        </div>
      </div>
    </div>
  );
}
